/**
 * Additional Notes field formatter
 */

import {useTextField} from '@hconnect/tuc-processes/fields/textField/useTextField'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter} from './types'
import {createValueArray} from './utils'

export const useAdditionalNotesFormatter = (): FieldFormatter => {
  const {fieldValue: additionalNotes, defaultFieldValue: defaultAdditionalNotes} =
    useTextField('additionalNotes')
  const additionalNotesState = useChangeableField('additionalNotes')

  return (context) => {
    const {t} = context
    const requiresApproval = additionalNotesState.state === 'requireDispatchConfirmation'
    const hasChanges = additionalNotesState.isDirty
    const oldValue = defaultAdditionalNotes || null
    const newValue = additionalNotes || null

    const values = createValueArray(
      oldValue,
      newValue,
      hasChanges,
      t('orderIntake.rmc.orderManagement.notSpecified', 'Not specified')
    )

    return {values, requiresApproval, hasChanges}
  }
}
